import { render, staticRenderFns } from "./MedicationEdit.vue?vue&type=template&id=3316ebcb&scoped=true&"
import script from "./MedicationEdit.vue?vue&type=script&lang=js&"
export * from "./MedicationEdit.vue?vue&type=script&lang=js&"
import style0 from "./MedicationEdit.vue?vue&type=style&index=0&id=3316ebcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316ebcb",
  null
  
)

export default component.exports